import { createEntityAdapter } from "@reduxjs/toolkit";
import { ResourceCalendarEvent } from "./dataTypes";

export const resourceCalendarEventAdapter = createEntityAdapter<ResourceCalendarEvent>({});
